export const getHistory = store => store.history?.orders

export const getPaymentInHistoryById = (store, paymentId) =>
  store.history?.orders?.find(payment => payment.id === paymentId)
